<template>
  <div>
    <div>
      <tabbar title="新闻详情" hasBack></tabbar>
    </div>
    <div class="line">

    </div>
    <div class="noticeInfo">
        <p>{{data.title}}</p>
        <div>
          发布时间：{{data.create_time*1000 | fmtDate('yyyy-MM-DD hh:mm:ss')}}
          <span class="liulan">浏览：4530次</span>
        </div>
        <div id="neirong"  v-html="data.text">
        </div>
    </div>
  </div>
</template>
<script>
    import tabbar from '@/components/common/tabbar';
    import * as util from "@/utils/network";
    import {
        Toast
    } from "vant";
    export default {
        data() {
            return {
                data: [],
            }
        },
        components: {
            tabbar,
        },
        mounted: function() {
            // this.getCourse(); //需要触发的函数
            this.getNotice(); //需要触发的函数
        },
        methods: {
            getNotice: function() {
                let that = this;
                var query = this.$route.query
                let id = query.id ? query.id : '';
                if (!id) {
                    Toast('参数错误');
                    return false;
                }
                util.post('/index/notice', {
                        id: id
                    },
                    function(result) {
                        that.data = result.data;
                    }
                )
            }
        }

    }
</script>
<style>
    .line {
        width: 3.75rem;
        height: 0.15rem;
        background: #F9F9F9;
    }
    
    .noticeInfo {
        margin: 0.15rem;
    }
    
    .noticeInfo>p {
        font-size: 0.17rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 0.38rem;
    }
    
    .noticeInfo>div {
        padding: 0.28rem 0.03rem 0 0;
        color: #8B8A8A;
        font-size: 0.13rem;
    }
    
    .liulan {
        float: right;
    }
    
    #neirong {
        font-size: 0.14rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #1E1E1E;
        line-height: 0.38rem;
    }
    
    #neirong img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/noticeInfo.vue